import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, LoadScriptNext } from "@react-google-maps/api";

const libraries = ["places"];

const Map = ({
  setMarkerPlace,
  setplaceerror,
  setcity,
  setcode,
  defaultLocation,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    console.log(defaultLocation);
    // 👇 Pre-fill the input with existing address if available
    if (defaultLocation?.address) {
      setSearchValue(defaultLocation.address);

      // Optionally pre-set markerPlace so parent can use it without new selection
      setMarkerPlace({
        formatted_address: defaultLocation.address,
        geometry: {
          location: {
            lat: () => defaultLocation.lat,
            lng: () => defaultLocation.lng,
          },
        },
      });
    }
  }, [defaultLocation]);

  const onPlaceChanged = () => {
    const place = autoCompleteRef.current.getPlace();

    if (!place?.geometry) {
      setSearchValue("");
      setplaceerror("Invalid place");
      setMarkerPlace(undefined);
      return;
    }

    const { lat, lng } = place.geometry.location;

    // Extract city & postal code
    place.address_components?.forEach((component) => {
      if (component.types.includes("locality")) {
        setcity && setcity(component.long_name);
      }
      if (component.types.includes("postal_code")) {
        setcode && setcode(component.long_name);
      }
    });

    if (!lat || !lng) {
      console.error("Invalid location data:", place.geometry.location);
      return;
    }

    setMarkerPlace(place);
    setSearchValue(place.formatted_address);
    setplaceerror("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") event.preventDefault();
  };

  return (
    <LoadScriptNext
      googleMapsApiKey="AIzaSyDb_u9uXPI3oJBv40IHjr5xgf4TvSET_gI"
      libraries={libraries}
    >
      <Autocomplete
        onLoad={(autoComplete) => (autoCompleteRef.current = autoComplete)}
        onPlaceChanged={onPlaceChanged}
      >
        <div className="Bookcaregiver_inputfield">
          <input
            type="text"
            placeholder="Address"
            className="Bookcaregiver_input"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyPress}
          />
        </div>
      </Autocomplete>
    </LoadScriptNext>
  );
};

export default Map;
